// @flow
import React from 'react';
import { makeStyles, useTheme } from '@material-ui/styles';
import Menu from '@material-ui/core/Menu';

const useStyles = makeStyles(theme => ({
  list: {
    paddingTop: 0,
    paddingBottom: 0,
    color: theme.palette.ava.dark1,
  },
}));

interface Props {
  id: string;
  children: Object;
  anchorEl: null | HTMLElement;
  anchorOrigin?: Object;
  transformOrigin?: Object;
  paperStyle?: Object;
  width: number;
  onClose: Function;
}

const DropdownMenu = ({ id, children, anchorEl, anchorOrigin, transformOrigin, paperStyle, width, onClose }: Props) => {
  const classes = useStyles();
  const theme = useTheme();

  const open = Boolean(anchorEl);

  return (
    <Menu
      id={id}
      anchorEl={anchorEl}
      open={open}
      getContentAnchorEl={null}
      onClose={onClose}
      onClick={onClose}
      classes={{
        list: classes.list,
      }}
      PaperProps={{
        style: {
          width,
          background: theme.palette.type === 'light' ? theme.palette.ava.white : theme.palette.ava.dark2,
          boxShadow:
            theme.palette.type === 'light'
              ? '0px 4px 24px rgba(112, 144, 176, 0.25)'
              : '0px 4px 4px rgba(112, 144, 176, 0.04)',
          borderRadius: 8,
          ...paperStyle,
        },
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
        ...anchorOrigin,
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
        ...transformOrigin,
      }}
    >
      {children}
    </Menu>
  );
};

export default DropdownMenu;
